import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { formatNumber } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { CostEstimationService } from '../../service/cost-estimation.service';
import { ClaimMarkersForCostEstimation } from '../../models/ClaimMarkersForCostEstimation';

@Component({
  selector: 'app-claim-markers-for-cost-estimation',
  templateUrl: './claim-markers-for-cost-estimation.component.html',
  styleUrls: ['./claim-markers-for-cost-estimation.component.scss']
})
export class ClaimMarkersForCostEstimationComponent implements OnInit {

  @Input() claimIdentifier: string;
  @Input() pdrLabourInvoicedPartially: number;
  @Input() pdrLabourInvoicedFinally: number;

  @Input() partsOriginalInvoicedPartially: number;
  @Input() partsOriginalInvoicedFinally: number;
  @Input() partsAlternativeInvoicedPartially: number;
  @Input() partsAlternativeInvoicedFinally: number;
  
  @Input() partsDiscountPartially: number;
  @Input() partsDiscountFinally: number;

  @Input() normaliesInvoicedPartially: number;
  @Input() normaliesInvoicedFinally: number;

  markers: ClaimMarkersForCostEstimation;
  isLoading = false;

  constructor(
    private costEstimationService: CostEstimationService,
    private translate: TranslateService,
    @Inject(LOCALE_ID) private locale: string) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.costEstimationService.getClaimMarkersForCostEstimation(this.claimIdentifier)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(markers => this.markers = markers);
  }

  calculatePdrLabourResult(): boolean {
    return (this.pdrLabourInvoicedPartially || 0) + (this.pdrLabourInvoicedFinally || 0) == (this.markers?.inspectionCardTotalAmount || 0);
  }

  calculatePartsResult(): boolean {
    return (this.partsOriginalInvoicedPartially || 0) + 
    (this.partsOriginalInvoicedFinally || 0) + 
    (this.partsAlternativeInvoicedPartially || 0) + 
    (this.partsAlternativeInvoicedFinally || 0)  - 
    (this.partsDiscountPartially || 0) - 
    (this.partsDiscountFinally || 0) 
    == (this.markers?.partsTotalValue || 0);
  }

  partsInvoicedPartiallyTooltip(): string {
    const original = this.translate.instant('claims-center.claimDetailsForm.partsOriginal');
    const alternative = this.translate.instant('claims-center.claimDetailsForm.partsAlternative');
    return `${original}: ${this.formatAmount(this.partsOriginalInvoicedPartially)}\n${alternative}: ${this.formatAmount(this.partsAlternativeInvoicedPartially)}`;
  }

  partsInvoicedFinallyTooltip(): string {
    const original = this.translate.instant('claims-center.claimDetailsForm.partsOriginal');
    const alternative = this.translate.instant('claims-center.claimDetailsForm.partsAlternative');
    return `${original}: ${this.formatAmount(this.partsOriginalInvoicedFinally)}\n${alternative}: ${this.formatAmount(this.partsAlternativeInvoicedFinally)}`;
  }

  private formatAmount(value: number): string {
    return formatNumber(value || 0, this.locale, '1.2-2');
  }

  calculateNormaliesResult(): boolean {
    return (this.normaliesInvoicedPartially || 0) + (this.normaliesInvoicedFinally || 0) == (this.markers?.normaliesValue || 0);
  }

  

}
